/* ============================================================
   gallery.js — renders the products-gallery-2026 filter bar and
   design grid from window.PS_DESIGNS (designs.js).
   Filter state lives in the URL hash (#rings, #rings/halo) so
   filtered views are shareable and the back button works.
   ============================================================ */
(function () {
  'use strict';
  var DATA = window.PS_DESIGNS;
  if (!DATA) return;

  var pillsHost = document.getElementById('psg-pills');
  var subsHost = document.getElementById('psg-subs');
  var grid = document.getElementById('psg-grid');
  var countEl = document.getElementById('psg-count');
  if (!pillsHost || !grid) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* On the Shopify port designs.js ships CDN-absolute image URLs; route to the page handle there. */
  var PORTED = /^(\/\/|https?:)/.test(((DATA.designs || [])[0] || {}).image || '');
  var CUSTOMIZE_URL = PORTED ? '/pages/design-customize?design=' : '../design-customize-2026/index.html?design=';

  var catByKey = {};
  DATA.categories.forEach(function (c) { catByKey[c.key] = c; });

  function designsFor(cat, sub) {
    return DATA.designs.filter(function (d) {
      if (cat && cat !== 'all' && d.category !== cat) return false;
      if (sub && d.subcats.indexOf(sub) === -1) return false;
      return true;
    });
  }

  /* ---------------- state from the hash ---------------- */
  function parseHash() {
    var h = (location.hash || '').replace(/^#/, '');
    if (!h || h === 'gallery') return { cat: 'all', sub: null };
    var parts = h.split('/');
    var cat = catByKey[parts[0]] ? parts[0] : 'all';
    var sub = null;
    if (cat !== 'all' && parts[1]) {
      catByKey[cat].subcats.forEach(function (s) { if (s.key === parts[1]) sub = s.key; });
    }
    return { cat: cat, sub: sub };
  }
  var state = parseHash();

  function setHash(cat, sub) {
    /* 'all' (not 'gallery') so the browser doesn't jump to the #gallery element on pill clicks */
    var h = cat === 'all' ? 'all' : cat + (sub ? '/' + sub : '');
    if (('#' + h) === location.hash) return;
    location.hash = h;
  }

  /* ---------------- rendering ---------------- */
  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function pill(label, count, pressed, cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.innerHTML = esc(label) + (count != null ? ' <em>' + count + '</em>' : '');
    b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    return b;
  }

  function renderPills() {
    pillsHost.innerHTML = '';
    var all = pill('All designs', DATA.designs.length, state.cat === 'all', 'psg-pill');
    all.addEventListener('click', function () { setHash('all', null); });
    pillsHost.appendChild(all);
    DATA.categories.forEach(function (c) {
      var b = pill(c.label, designsFor(c.key, null).length, state.cat === c.key, 'psg-pill');
      b.addEventListener('click', function () { setHash(c.key, null); });
      pillsHost.appendChild(b);
    });
  }

  function renderSubs() {
    subsHost.innerHTML = '';
    var cat = state.cat !== 'all' && catByKey[state.cat];
    if (!cat || cat.subcats.length < 2) { subsHost.hidden = true; return; }
    subsHost.hidden = false;
    var all = pill('All ' + cat.label.toLowerCase(), null, !state.sub, 'psg-sub');
    all.addEventListener('click', function () { setHash(cat.key, null); });
    subsHost.appendChild(all);
    cat.subcats.forEach(function (s) {
      var n = designsFor(cat.key, s.key).length;
      if (!n) return;
      var b = pill(s.label, n, state.sub === s.key, 'psg-sub');
      b.addEventListener('click', function () { setHash(cat.key, s.key); });
      subsHost.appendChild(b);
    });
  }

  function subLabel(d) {
    var cat = catByKey[d.category];
    /* Label from the ACTIVE filter when the design carries it, so a cross-listed
       design never shows a foreign eyebrow inside a filtered view. */
    var key = (state.sub && d.subcats.indexOf(state.sub) > -1) ? state.sub : d.subcats[0];
    var label = '';
    cat.subcats.forEach(function (s) { if (s.key === key) label = s.label; });
    return label;
  }

  function renderGrid() {
    var list = designsFor(state.cat, state.sub);
    grid.innerHTML = '';
    list.forEach(function (d, i) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'psg-card';
      a.href = CUSTOMIZE_URL + encodeURIComponent(d.slug);
      a.innerHTML =
        '<span class="psg-card-img"><img src="' + esc(d.image) + '" alt="' + esc(d.alt) + '" width="' + d.w + '" height="' + d.h + '" loading="' + (i < 8 ? 'eager' : 'lazy') + '"></span>' +
        '<span class="psg-card-body">' +
        '<span class="psg-card-sub">' + esc(subLabel(d)) + '</span>' +
        '<strong class="psg-card-name">' + esc(d.name) + '</strong>' +
        '<span class="psg-card-cta"><span class="long">Customize this design</span><span class="brief">Customize</span></span>' +
        '</span>';
      if (!REDUCED) a.style.animationDelay = Math.min(i, 11) * 0.03 + 's';
      li.appendChild(a);
      grid.appendChild(li);
    });
    var what = '';
    if (state.cat !== 'all') {
      what = catByKey[state.cat].label;
      if (state.sub) {
        catByKey[state.cat].subcats.forEach(function (s) { if (s.key === state.sub) what = s.label; });
      }
    }
    if (countEl) countEl.innerHTML = '<b>' + list.length + '</b> design' + (list.length === 1 ? '' : 's') + (what ? ' &middot; ' + esc(what) : ' &middot; every one customizable');
  }

  function render() {
    renderPills();
    renderSubs();
    renderGrid();
  }

  window.addEventListener('hashchange', function () {
    var next = parseHash();
    var changed = next.cat !== state.cat || next.sub !== state.sub;
    state = next;
    if (changed) render();
  });

  render();

  /* Deep link (#rings/halo): there is no element with that id, so the browser
     didn't scroll — bring the gallery into view ourselves. */
  if (location.hash && location.hash !== '#gallery' && state.cat !== 'all') {
    var gal = document.getElementById('gallery');
    if (gal) gal.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
  }
})();
